function showmorebuttonarticles() {
    if ($('.blog_category_page .pagination_container .pagination li:last-child a').hasClass('has_link')) {
		var more_button = $('.more_button_text').text();
        $('.more_button_container').html('<button onclick="showmorearticles()" id="showmorearticles" class="reset_button button black_button" id="more_articles"><span class="text">' + more_button + '</span></button>');

    }
}

function showmorearticles() {

    var $next = $('.blog_category_page .pagination_container .pagination li:last-child a.has_link');
	
    if ($next.length == 0) {
        return;
    }
    $.get($next.attr('href'), function (data) {
        $data = $(data);

        //console.log($data);

        var $container = $('.blog_category_page .articles_row');
		//$container.append($data.find('.products_row .item'));
        $container.append($data.find('.articles_row .article'));
		
		//products_counter();
        $('.bottom-wrapper').remove();
        $(".blog_category_page").append($(data).find('.bottom-wrapper'));

        showmorebuttonarticles();

        if ($('.blog_category_page .pagination li.active').next('li').find('a.has_link').length == 0) {
            $('#showmorearticles').hide();
        }



    }, "html");
    return false;
}
